module.exports = __webpack_public_path__ + "58830bfdf2eb9b4a7197365fdd56761a.png";